import React from 'react';
import EditComp from './EditComp';
import { Steps, Button, Breadcrumb, Icon, Spin, Collapse, Affix, Tree, Modal, Popover } from 'antd';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import SERVER_URL from '../Global';
import queryString from 'query-string';
import CardDetailed from '../util/compCardDetailed';

const { TreeNode } = Tree;
const { Step } = Steps;
const { Panel } = Collapse;

export class EditWizard extends React.Component {
    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);

        this.state = {
            user: this.props.token,
            workflow: 0,
            compLoad: true,
            compId: null,
            openerId: params.id,
            opener: null,
            fatherId: null,
            detailsComp: ['0'],
            companies: [],
            loadingBranch: true,
            iconMap: [],
            hasDetail: false,
            companyDetail: [],
            alreadyLoaded: [],
            properties: [],
            tipologies: []
        };

        this.changeStep = this.changeStep.bind(this);
        this.switchChange = this.switchChange.bind(this);
        this.loadAllFamily = this.loadAllFamily.bind(this);
        this.recursiveFetch = this.recursiveFetch.bind(this);
        this.branchClicked = this.branchClicked.bind(this);
        this.treeHierarchy = this.treeHierarchy.bind(this);
        this.changeAccordion = this.changeAccordion.bind(this);
        this.showModal = this.showModal.bind(this);
        this.loadNewEdit = this.loadNewEdit.bind(this);
    }

    componentDidMount() {
        
        //tipologie
        fetch(
            `${SERVER_URL + 'api/translation/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "typeTip": "CompanyTypology",
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ tipologies: res.data });
                } else {
                    this.setState({ tipologies: [] });
                }
            })

        //proprietà
        fetch(
            `${SERVER_URL + 'api/translation/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "typeTip": "Property",
                    "page": 1,
                    "pageSize": 40
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ properties: res.data }, this.setState({ propLoad: false }));
                } else {
                    this.setState({ properties: [] });
                }
            })

        this.recursiveFetch(this.state.openerId, this.state.user)
    }

    recursiveFetch(id, token) {
        fetch(
            `${SERVER_URL + 'api/company/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({
                    "companyId": id,
                    "page": 1,
                    "PageSize": 1,
                    "ordering": {
                        "orderPropertyName": "companyname",
                        "order": 1
                    }
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    if (res.data[0].companyParentCompanyId != null) {
                        this.recursiveFetch(res.data[0].companyParentCompanyId, token)
                    } else {
                        this.loadAllFamily(id)
                    }
                }
                else {
                    window.location = "/";
                }
            })
    }

    changeAccordion() {
        this.setState({ loadingBranch: false })
    }

    loadAllFamily(id) {

        if (id != this.state.openerId) {

            fetch(
                `${SERVER_URL + 'api/company/' + this.state.openerId + '?lang=en'}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
            ).then(response => response.json())
                .then(res => {

                    let companies = []

                    let companyOpener = res.data
                    //companies
                    fetch(
                        `${SERVER_URL + 'api/company/' + id + '?lang=en'}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${this.state.user}`,
                            'Content-Type': 'application/json'
                        }
                    }
                    ).then(response => response.json())
                        .then(res => {
                            this.setState({ workflow: res.data.workflow })

                            companies.push(res.data)

                            recursiveMap(res.data)

                            function recursiveMap(comp) {
                                comp.companySons.map(son => {
                                    companies.push(son)

                                    if (son.companySons.length > 0) {
                                        return recursiveMap(son)
                                    }
                                })
                            }

                            var title = "Polar - Edit " + res.data.name
                            document.title = title

                            let iconMap = []

                            companies.map(comp => {
                                if (comp.companyTypologyTrValue === 1) {
                                    iconMap.push({ id: comp.companyId, icon: 'companies' })
                                } else if (comp.companyTypologyTrValue === 2) {
                                    iconMap.push({ id: comp.companyId, icon: 'brands' })
                                } else if (comp.companyTypologyTrValue === 17) {
                                    iconMap.push({ id: comp.companyId, icon: 'sign' })
                                } else if (comp.companyTypologyTrValue === 20) {
                                    iconMap.push({ id: comp.companyId, icon: 'department' })
                                }
                            })

                            let opener = this.state.openerId
                            var foundIndex = companies.findIndex(x => x.companyId == opener);
                            companies[foundIndex] = companyOpener
                            this.setState({ opener: opener, fatherId: companies[0].companyId, compLoad: false, companies: companies, loadingBranch: false, iconMap: iconMap, compId: id })

                        })
                })
        } else {
            fetch(
                `${SERVER_URL + 'api/company/' + id + '?lang=en'}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
            ).then(response => response.json())
                .then(res => {

                    let companies = []

                    let companyOpener = res.data

                    this.setState({ workflow: res.data.workflow })

                    companies.push(res.data)

                    recursiveMap(res.data)

                    function recursiveMap(comp) {
                        comp.companySons.map(son => {
                            companies.push(son)

                            if (son.companySons.length > 0) {
                                return recursiveMap(son)
                            }
                        })
                    }

                    var title = "Polar - Edit " + res.data.name
                    document.title = title

                    let iconMap = []

                    companies.map(comp => {
                        if (comp.companyTypologyTrValue === 1) {
                            iconMap.push({ id: comp.companyId, icon: 'companies' })
                        } else if (comp.companyTypologyTrValue === 2) {
                            iconMap.push({ id: comp.companyId, icon: 'brands' })
                        } else if (comp.companyTypologyTrValue === 17) {
                            iconMap.push({ id: comp.companyId, icon: 'sign' })
                        } else if (comp.companyTypologyTrValue === 20) {
                            iconMap.push({ id: comp.companyId, icon: 'department' })
                        }
                    })

                    let opener = this.state.openerId

                    var foundIndex = companies.findIndex(x => x.companyId == opener);

                    companies[foundIndex] = companyOpener

                    this.setState({ opener: opener, fatherId: companies[0].companyId, compLoad: false, companies: companies, loadingBranch: false, iconMap: iconMap, compId: id })
                })
        }
    }

    treeHierarchy(comp, parentId) {
        let company = () => (
            <svg id="Layer_c" data-name="Layer c" viewBox="0 0 500 500"><path style={{ fill: '#213a66' }} className="cls-1" d="M335.17,358.73Q309.63,372,271.63,372q-49.2,0-78.84-31.06T163.15,259.4q0-54.24,33.35-87.67t84.27-33.42q32.79,0,54.4,9.3v37.21a97.07,97.07,0,0,0-50.46-13.56q-36.73,0-59.52,23.49t-22.78,62.76q0,37.37,21.29,59.52t56,22.15q32,0,55.5-15.14Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M390.13,132.71V77h-275v55.71H37.33V441H468V132.71ZM133.52,423.56V94.44H371.79V423.56ZM54.9,150.41h60.27V423.3H54.9ZM450.07,423.3H390.13V150.41h59.94Z" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="188.43" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="244.14" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="188.43" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="244.14" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="299.86" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="299.86" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="356.5" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="356.5" width="27.86" height="27.86" /></svg>
        )

        let brand = () => (
            <svg id="Layer_b" data-name="Layer b" viewBox="0 0 500 500"><path style={{ fill: '#213a66' }} className="cls-1" d="M168.06,336V69h76Q278.65,69,299,85.94t20.3,44.13q0,22.73-12.29,39.47t-33.89,23.84v.74q27,3.16,43.2,20.39t16.2,44.78q0,34.26-24.58,55.48t-62,21.23ZM199.34,97.3v86.21h32q25.69,0,40.41-12.38t14.71-34.91q0-38.93-51.21-38.92Zm0,114.32V307.7h42.45q27.56,0,42.73-13t15.18-35.75q0-47.3-64.43-47.3Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M74.63,225a75.65,75.65,0,0,1,9,4.23l7.49-6.42a73.59,73.59,0,0,0,8.16-103.62L97.47,117l-10.85,9.21A73.56,73.56,0,0,0,74.63,225Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M51.73,234.14l-1.8,7.45a68.4,68.4,0,0,0,33,75.77A84.77,84.77,0,0,1,111,312.87a68.71,68.71,0,0,0-30.69-67.8l-.13-.09a59.47,59.47,0,0,0-12.92-6.43l-2.14-.76a63.14,63.14,0,0,0-6.11-1.85Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M137.19,384.8a84,84,0,0,1,38.17-9.69l-2.46-5.73a68.72,68.72,0,0,0-88.06-36.64c-.17.09-.76.32-1.3.53l-8,3.43,3,7A68,68,0,0,0,137.19,384.8Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M225.12,421.18l5.4-5.39-5.41-5.41a68.78,68.78,0,0,0-97.18,0l-5.4,5.41,5.4,5.39A68.79,68.79,0,0,0,225.12,421.18Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M415.39,225a75.65,75.65,0,0,0-9,4.23l-7.49-6.42a73.59,73.59,0,0,1-8.16-103.62l1.84-2.15,10.85,9.21A73.56,73.56,0,0,1,415.39,225Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M438.29,234.14l1.8,7.45a68.4,68.4,0,0,1-33,75.77A84.77,84.77,0,0,0,379,312.87,68.7,68.7,0,0,1,409.67,245l.13-.09a59.47,59.47,0,0,1,12.92-6.43l2.14-.76a63.14,63.14,0,0,1,6.11-1.85Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M352.83,384.8a84,84,0,0,0-38.18-9.69l2.47-5.73a68.71,68.71,0,0,1,88.09-36.6c.17.09.77.31,1.3.53l8,3.44-3.05,7.05A68,68,0,0,1,352.83,384.8Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M264.9,421.18l-5.4-5.39,5.41-5.41a68.78,68.78,0,0,1,97.18,0l5.4,5.41-5.4,5.39A68.79,68.79,0,0,1,264.9,421.18Z" /></svg>
        )

        let sign = () => (
            <svg id="Layer_s" data-name="Layer s" viewBox="0 0 500 500"><path style={{ fill: '#1890ff' }} className="cls-1" d="M431,179.5v168H69v-168H431m19-19H50v206H450v-206Z" /><path style={{ fill: '#213a66' }} className="cls-2" d="M334.28,124.68q-29.92-13.11-67.85-13.11A159.14,159.14,0,0,0,225,117a117.34,117.34,0,0,0-35.78,16.11,83.37,83.37,0,0,0-25.09,26.52q-9.41,15.81-9.41,36.35,0,16.81,5,29.36a65.76,65.76,0,0,0,14.83,22.38A102.57,102.57,0,0,0,199,265.38a336.53,336.53,0,0,0,34.06,15.53q14,5.43,26.09,10.41a110.07,110.07,0,0,1,21.1,11.26A52.64,52.64,0,0,1,294.51,317q5.28,8.11,5.28,19.81,0,41.06-61.58,41A136.24,136.24,0,0,1,182,366H154.1v33.79q33.08,17.4,78.12,17.4a181.21,181.21,0,0,0,43.62-5.14,116.63,116.63,0,0,0,36.77-15.68,81.73,81.73,0,0,0,25.52-26.51q9.56-16,9.55-37.63,0-17.67-5.84-30.51a69.2,69.2,0,0,0-16.68-22.66,119.59,119.59,0,0,0-26.23-17.68,364.93,364.93,0,0,0-34.78-15.25q-14.53-5.7-25.94-10.55a92.42,92.42,0,0,1-19.39-10.83,42.05,42.05,0,0,1-12.12-13.69q-4.12-7.69-4.13-19.1a34.19,34.19,0,0,1,4.13-16.67,38.94,38.94,0,0,1,11.69-13,58.27,58.27,0,0,1,18.11-8.41,86.75,86.75,0,0,1,23.66-3q29,0,53.31,10.09h20.81Z" /></svg>
        )

        let department = () => (
            <svg id="Layer_d" data-name="Layer d" viewBox="0 0 500 500"><polygon style={{ fill: '#1890ff' }} className="cls-1" points="481.25 69 248.08 69 248.08 83.59 432.6 83.59 432.6 302.16 481.25 302.16 481.25 69" /><polygon style={{ fill: '#1890ff' }} className="cls-1" points="86.85 207.84 39.3 207.84 39.3 441 272.46 441 272.46 420.34 86.85 420.34 86.85 207.84" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M416.27,99V411h-312V99h312m17-17h-346V428h346V82Z" /><path style={{ fill: '#213a66' }} className="cls-1" d="M155.9,379V131h71.6q137.14,0,137.14,120.89,0,57.42-38.05,92.26T224.56,379Zm36-220.17V351.34H227.4q46.87,0,72.92-25.77t26-72.82q0-93.92-97.28-93.92Z" /></svg>
        )

        let icona = comp.companyTypologyTrValue == 1 ? company : comp.companyTypologyTrValue == 2 ? brand : comp.companyTypologyTrValue == 17 ? sign : department

        if (comp.companyParentCompanyId === parentId) {
            return (
                <TreeNode icon={<Icon component={icona} />} title={comp.name} key={[`${comp.companyId}`]}>
                    {comp.companySons.map((son, i) =>
                        this.treeHierarchy(son, comp.companyId)
                    )}
                </TreeNode>
            )
        }
    }

    changeStep = current => {
        this.setState({ workflow: current });
    };


    switchChange = e => {
        this.setState({
            status: e.target.value,
        });
    };

    branchClicked(selectedKeys, info) {
        //al click nel tree, si apre l'accordion e la finestra scrolla a quell'altezza
        if (selectedKeys[0] !== '0' && selectedKeys.length > 0) {
            let alreadyLoaded = this.state.alreadyLoaded
            alreadyLoaded.push({ id: selectedKeys[0] })

            window.setTimeout(function () {
                document.getElementById(selectedKeys).scrollIntoView()
            }, 700)

            fetch(
                `${SERVER_URL + 'api/company/' + selectedKeys[0] + '?lang=en'}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).then(response => response.json())
                .then(res => {
                    let companies = this.state.companies

                    var foundIndex = companies.findIndex(x => x.companyId == selectedKeys);

                    companies[foundIndex] = res.data

                    this.setState({ companies: companies })

                    this.setState({ opener: selectedKeys, loadingBranch: true, alreadyLoaded: alreadyLoaded })
                })
        } else if (selectedKeys[0] === '0' && selectedKeys.length > 0) {
            //nel caso in cui la key sia 0, apro la prima compagnia (il padre)
            let alreadyLoaded = this.state.alreadyLoaded
            alreadyLoaded.push({ id: this.state.companies[0].companyId })

            var opener = this.state.companies[0].companyId

            fetch(
                `${SERVER_URL + 'api/company/' + opener + '?lang=en'}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).then(response => response.json())
                .then(res => {
                    let companies = this.state.companies

                    companies[0] = res.data

                    this.setState({ companies: companies })
                })

            this.setState({ opener: opener, loadingBranch: true, alreadyLoaded: alreadyLoaded })

            window.setTimeout(function () {
                document.getElementById(opener).scrollIntoView()
            }, 700)
        } else {
            this.setState({ opener: null })
        }
    }

    showModal() {
        this.setState({ companyDetail: [], hasDetail: false })
            fetch(
                `${SERVER_URL + 'api/company/' + this.state.opener + '?lang=en'}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).then(response => response.json())
                .then(res => {
                this.setState({ companyDetail: res.data, hasDetail: true, visible: true })
            })
    }

    reloadPage() {
        window.location = "/";
    }

    loadNewEdit(id) {
        if (id != null) {
            let double = this.state.iconMap.findIndex(obj => obj.id == id)

            if (double == -1) {
                window.location = "/edit?id=" + id;
            } else {
                let listaId = [id]
                this.branchClicked(listaId, false)
                this.setState({ visible: false, loadingDetail: false })
            }
        }
    }

    goBack() {
        return window.open("/", '_self');
    }

    callbackFunction = (childId) => {      
        this.setState({ openerId: childId, opener: childId})
        this.recursiveFetch(childId, this.state.user)
        
    }

    render() {

        let blockFooter = true

        let detail = !this.state.hasDetail ?
            ''
            : <Modal
                key={this.state.companyDetail.companyId}
                title={this.state.companyDetail.name}
                onCancel={() => this.setState({ visible: false, loadingDetail: false })}
                visible={this.state.visible}
                footer={null}
            >
                <CardDetailed crossFetch={this.reloadPage} getDetail={this.loadNewEdit} token={this.state.user} company={this.state.companyDetail} blockFooter={blockFooter} />
            </Modal>

        let treeFamily = !this.state.compLoad ?
            this.state.companies.map((comp, i) => {
                if (i != 0) { return this.treeHierarchy(comp, this.state.companies[0].companyId) }
            }) : ''
          
            let compHandle = !this.state.compLoad ?
    
            this.state.companies.map((comp, i) => {

                let companies = this.state.companies

                    let paddingLevel = 0

                    let hyphonNumber = []

                findFather(comp)

                function findFather(comp) {

                    var indexOrder = companies.findIndex(obj => obj.companyId == comp.companyParentCompanyId)

                    if (indexOrder !== -1) {
                        paddingLevel = paddingLevel + 1

                        hyphonNumber.push(paddingLevel)

                        findFather(companies[indexOrder])
                    }
                }

                paddingLevel = paddingLevel * 15

                    let fatherPadding = comp.companyParentCompanyId ? true : false

                    let companyNameHeaderOld = <h3 style={{ paddingLeft: paddingLevel + "px" }} className={"fatherPadding " + fatherPadding}> - {comp.name}  - ({comp.companyTypology.text})</h3>

                    let companyNameHeader = <h3 className={"fatherPadding " + fatherPadding}> {hyphonNumber.map(i => { return ("-") })} {comp.name}  - ({comp.companyTypology.text})</h3>
                    return (
                        <Panel showArrow={false} id={"" + comp.companyId + ""} className={"fatherBG " + fatherPadding} header={companyNameHeaderOld} key={comp.companyId}>
                            <EditComp parentCallback={this.callbackFunction} changeAccordion={this.changeAccordion} key={comp.companyId} workFlow={this.state.workflow} company={comp} user={this.state.user} properties={this.state.properties} tipologies={this.state.tipologies} />
                        </Panel>
                    )
                }
            )
            : <Spin style={{ marginTop: "40px" }} />

        let accordion = this.state.opener != null ?
            <Collapse onChange={this.changeAccordion} activeKey={[`${this.state.opener}`]} destroyInactivePanel={true} accordion={true}>
                {compHandle}
            </Collapse> : ''

        let company = () => (
            <svg id="Layer_c" data-name="Layer c" viewBox="0 0 500 500"><path style={{ fill: '#213a66' }} className="cls-1" d="M335.17,358.73Q309.63,372,271.63,372q-49.2,0-78.84-31.06T163.15,259.4q0-54.24,33.35-87.67t84.27-33.42q32.79,0,54.4,9.3v37.21a97.07,97.07,0,0,0-50.46-13.56q-36.73,0-59.52,23.49t-22.78,62.76q0,37.37,21.29,59.52t56,22.15q32,0,55.5-15.14Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M390.13,132.71V77h-275v55.71H37.33V441H468V132.71ZM133.52,423.56V94.44H371.79V423.56ZM54.9,150.41h60.27V423.3H54.9ZM450.07,423.3H390.13V150.41h59.94Z" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="188.43" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="244.14" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="188.43" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="244.14" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="299.86" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="299.86" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="70.65" y="356.5" width="27.86" height="27.86" /><rect style={{ fill: '#1890ff' }} className="cls-2" x="406.8" y="356.5" width="27.86" height="27.86" /></svg>
        )

        let brand = () => (
            <svg id="Layer_b" data-name="Layer b" viewBox="0 0 500 500"><path style={{ fill: '#213a66' }} className="cls-1" d="M168.06,336V69h76Q278.65,69,299,85.94t20.3,44.13q0,22.73-12.29,39.47t-33.89,23.84v.74q27,3.16,43.2,20.39t16.2,44.78q0,34.26-24.58,55.48t-62,21.23ZM199.34,97.3v86.21h32q25.69,0,40.41-12.38t14.71-34.91q0-38.93-51.21-38.92Zm0,114.32V307.7h42.45q27.56,0,42.73-13t15.18-35.75q0-47.3-64.43-47.3Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M74.63,225a75.65,75.65,0,0,1,9,4.23l7.49-6.42a73.59,73.59,0,0,0,8.16-103.62L97.47,117l-10.85,9.21A73.56,73.56,0,0,0,74.63,225Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M51.73,234.14l-1.8,7.45a68.4,68.4,0,0,0,33,75.77A84.77,84.77,0,0,1,111,312.87a68.71,68.71,0,0,0-30.69-67.8l-.13-.09a59.47,59.47,0,0,0-12.92-6.43l-2.14-.76a63.14,63.14,0,0,0-6.11-1.85Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M137.19,384.8a84,84,0,0,1,38.17-9.69l-2.46-5.73a68.72,68.72,0,0,0-88.06-36.64c-.17.09-.76.32-1.3.53l-8,3.43,3,7A68,68,0,0,0,137.19,384.8Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M225.12,421.18l5.4-5.39-5.41-5.41a68.78,68.78,0,0,0-97.18,0l-5.4,5.41,5.4,5.39A68.79,68.79,0,0,0,225.12,421.18Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M415.39,225a75.65,75.65,0,0,0-9,4.23l-7.49-6.42a73.59,73.59,0,0,1-8.16-103.62l1.84-2.15,10.85,9.21A73.56,73.56,0,0,1,415.39,225Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M438.29,234.14l1.8,7.45a68.4,68.4,0,0,1-33,75.77A84.77,84.77,0,0,0,379,312.87,68.7,68.7,0,0,1,409.67,245l.13-.09a59.47,59.47,0,0,1,12.92-6.43l2.14-.76a63.14,63.14,0,0,1,6.11-1.85Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M352.83,384.8a84,84,0,0,0-38.18-9.69l2.47-5.73a68.71,68.71,0,0,1,88.09-36.6c.17.09.77.31,1.3.53l8,3.44-3.05,7.05A68,68,0,0,1,352.83,384.8Z" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M264.9,421.18l-5.4-5.39,5.41-5.41a68.78,68.78,0,0,1,97.18,0l5.4,5.41-5.4,5.39A68.79,68.79,0,0,1,264.9,421.18Z" /></svg>
        )

        let sign = () => (
            <svg id="Layer_s" data-name="Layer s" viewBox="0 0 500 500"><path style={{ fill: '#1890ff' }} className="cls-1" d="M431,179.5v168H69v-168H431m19-19H50v206H450v-206Z" /><path style={{ fill: '#213a66' }} className="cls-2" d="M334.28,124.68q-29.92-13.11-67.85-13.11A159.14,159.14,0,0,0,225,117a117.34,117.34,0,0,0-35.78,16.11,83.37,83.37,0,0,0-25.09,26.52q-9.41,15.81-9.41,36.35,0,16.81,5,29.36a65.76,65.76,0,0,0,14.83,22.38A102.57,102.57,0,0,0,199,265.38a336.53,336.53,0,0,0,34.06,15.53q14,5.43,26.09,10.41a110.07,110.07,0,0,1,21.1,11.26A52.64,52.64,0,0,1,294.51,317q5.28,8.11,5.28,19.81,0,41.06-61.58,41A136.24,136.24,0,0,1,182,366H154.1v33.79q33.08,17.4,78.12,17.4a181.21,181.21,0,0,0,43.62-5.14,116.63,116.63,0,0,0,36.77-15.68,81.73,81.73,0,0,0,25.52-26.51q9.56-16,9.55-37.63,0-17.67-5.84-30.51a69.2,69.2,0,0,0-16.68-22.66,119.59,119.59,0,0,0-26.23-17.68,364.93,364.93,0,0,0-34.78-15.25q-14.53-5.7-25.94-10.55a92.42,92.42,0,0,1-19.39-10.83,42.05,42.05,0,0,1-12.12-13.69q-4.12-7.69-4.13-19.1a34.19,34.19,0,0,1,4.13-16.67,38.94,38.94,0,0,1,11.69-13,58.27,58.27,0,0,1,18.11-8.41,86.75,86.75,0,0,1,23.66-3q29,0,53.31,10.09h20.81Z" /></svg>
        )

        let department = () => (
            <svg id="Layer_d" data-name="Layer d" viewBox="0 0 500 500"><polygon style={{ fill: '#1890ff' }} className="cls-1" points="481.25 69 248.08 69 248.08 83.59 432.6 83.59 432.6 302.16 481.25 302.16 481.25 69" /><polygon style={{ fill: '#1890ff' }} className="cls-1" points="86.85 207.84 39.3 207.84 39.3 441 272.46 441 272.46 420.34 86.85 420.34 86.85 207.84" /><path style={{ fill: '#1890ff' }} className="cls-2" d="M416.27,99V411h-312V99h312m17-17h-346V428h346V82Z" /><path style={{ fill: '#213a66' }} className="cls-1" d="M155.9,379V131h71.6q137.14,0,137.14,120.89,0,57.42-38.05,92.26T224.56,379Zm36-220.17V351.34H227.4q46.87,0,72.92-25.77t26-72.82q0-93.92-97.28-93.92Z" /></svg>
        )


        let icona = this.state.compLoad ? '' : this.state.companies[0].companyTypologyTrValue == 1 ? company : this.state.companies[0].companyTypologyTrValue == 2 ? brand : this.state.companies[0].companyTypologyTrValue == 17 ? sign : department


        let tree = !this.state.compLoad ? <Tree
            showIcon
            switcherIcon={<Icon type="down" />}
            onSelect={this.branchClicked}
            defaultExpandAll
            selectedKeys={[`${this.state.opener}`]}
            className={"treeWizard " + this.state.loadingBranch}
            key="1"
        >
            <TreeNode icon={<Icon component={icona} />} title={this.state.companies[0].name} key={this.state.fatherId}>
                {treeFamily}
            </TreeNode>
        </Tree> : ''

        let preview = this.state.opener != null ? <Button className="previewWizard" onClick={this.showModal} type="primary" icon="profile">
            Check preview
            </Button> : <Popover content="Choose a company" trigger="hover"><Button style={{width: '100%'}} className="previewWizard" disabled={true} type="primary" icon="profile">
                    Check preview
                </Button>
            </Popover>

        return (
            <Container fluid={true}>
                <Row className="specialBread">
                    <Col sm="12" style={{ display: 'inline-flex' }}>
                        <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>Edit</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Col style={{ minHeight: '93vh' }} sm='12'>

                        <div className="wizardFields wizardContacts">

                            <div className="wizardBackground">

                                <Steps current={this.state.workflow} onChange={this.changeStep}>
                                    <Step title="Inserted" description="Data insert completed" icon={<Icon type="file-add" />} />
                                    <Step title="Under review" description="Editing required" icon={<Icon type="exception" />} />
                                    <Step title="To Verify" description="Waiting for approval" icon={<Icon type="solution" />} />
                                    <Step title="Approved" description="Ready to be published" icon={<Icon type="file-protect" />} />
                                    <Step title="Published" description="Content online" icon={<Icon type="file-done" />} />
                                </Steps>

                                <hr style={{ width: 'calc(100% - 60px)', marginLeft: '30px' }} />

                                <Row style={{ margin: '0' }}>

                                    <Col className="affixBackground" style={{ paddingLeft: '30px' }} sm="2">
                                        <Affix offsetTop={20}>

                                            {preview}

                                            <hr style={{ marginTop: '15px', marginBottom: '5px' }} />

                                            {tree}
                                        </Affix>
                                    </Col>

                                    {detail}

                                    <Col sm="10" className="createCompBoxPad">
                                        <Row>
                                            {accordion}
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/EditWizard/EditWizard.js